import { Reveal } from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import LeadForm from "@/components/LeadForm";
import ContactInfo from "@/components/ContactInfo";
import { CONTATO, CONTATO_PAGINA } from "@/content/site";

const Contato = () => (
  <main className="pt-28 lg:pt-36">
    <section data-testid="contact-page" className="mx-auto grid max-w-7xl gap-14 px-6 pb-24 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-5">
        <SectionHeading overline={CONTATO_PAGINA.overline} lines={CONTATO_PAGINA.titulo.map((l) => <>{l}</>)} texto={CONTATO_PAGINA.texto} large inView={false} />
        <Reveal delay={0.3}>
          <div className="mt-12">
            <ContactInfo />
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal delay={0.2}>
          <div className="border border-white/10 bg-coal p-8 lg:p-10">
            <p className="font-serif text-2xl text-[#F4F4F6]">Envie sua mensagem</p>
            <p className="mt-2 text-sm font-light text-stone-400">Respondemos o mais rápido possível, em horário comercial.</p>
            <div className="mt-8">
              <LeadForm tipo="contato" testidPrefix="contact" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>

    <section data-testid="contact-map" className="border-t border-white/10 bg-coal">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10">
        <SectionHeading overline="Onde estamos" lines={[<>Venha nos visitar</>, <>no Centro de {CONTATO.cidade}.</>]} />
        <Reveal delay={0.2}>
          <div className="mt-12 overflow-hidden border border-white/10 grayscale transition-[filter] duration-700 hover:grayscale-0">
            <iframe
              title={`Mapa — ${CONTATO.endereco}, ${CONTATO.cidade}`}
              src={CONTATO.mapaEmbed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="h-[380px] w-full lg:h-[460px]"
              data-testid="contact-map-iframe"
            />
          </div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default Contato;
